import {
    Dialog,
    DialogDismiss,
    DialogHeader,
    DialogHeading,
    DialogBody,
    DialogDisclosure
} from '@/components/ui/dialog-atoms/DialogAtoms'
import {useTranslation} from '@/translations/i18n'
import {DialogProvider, DialogStore} from '@ariakit/react'
import {AccessForm} from '../access-forms/AccessForm'
import {AccessFormProvider} from '../access-forms/AccessFormProvider'
import {AccessDialogFooter} from '../create-access-dialog/AccessDialogFooter'
import {Access} from '../../types'
import {mapAccessToFormValues} from '../../utils'
import {ReactElement, useMemo} from 'react'
import {useGetAccess} from '../../queries/useGetAccess'
import {EditAccessDialogSkeleton} from './EditAccessDialogSkeleton'

interface EditAccessDialogProps {
    access: Access
    dialogStore?: DialogStore
    trigger?: ReactElement
}

export const EditAccessDialog = ({access, dialogStore, trigger}: EditAccessDialogProps) => {
    return (
        <DialogProvider store={dialogStore}>
            {trigger ? <DialogDisclosure render={trigger} /> : null}
            <Dialog width="680px" overflowY="unset">
                <EditAccessDialogContent access={access} />
            </Dialog>
        </DialogProvider>
    )
}

interface EditAccessDialogContentProps {
    access: Access
}

const EditAccessDialogContent = ({access}: EditAccessDialogContentProps) => {
    const {t} = useTranslation()

    const {data: missedAccess, isLoading} = useGetAccess({
        urlParams: {accessId: access.event.missedAccessId || ''},
        options: {enabled: !!access.event.missedAccessId}
    })

    const defaultValues = useMemo(() => mapAccessToFormValues(access, missedAccess), [access, missedAccess])

    return (
        <>
            <DialogHeader>
                <DialogHeading>{t('accesses:edit_access')}</DialogHeading>
                <DialogDismiss />
            </DialogHeader>

            {isLoading ? (
                <EditAccessDialogSkeleton />
            ) : (
                <AccessFormProvider defaultValues={defaultValues}>
                    <DialogBody>
                        <AccessForm isEdit />
                    </DialogBody>
                    <AccessDialogFooter accessId={access.id} />
                </AccessFormProvider>
            )}
        </>
    )
}
